/**
 * Порожній список (UIUX patterns/empty-states, tables/empty-and-loading): одне речення — чого немає і як це змінити — і дія, яку користувач
 * може виконати: зі звуженими фільтрами — «Скинути фільтри»; у пункті меню з власним відбором і без записів узагалі — «+ Створити …»
 * (якщо можна створювати). Чиста функція.
 */
export function emptyStateOf(
  o: { narrowed: boolean; filtered: boolean; item: string; create: string; canCreate: boolean },
  t: (key: string, vars?: Record<string, string>) => string,
): { text: string; action: 'reset' | 'create' | null; actionText: string } {
  if (o.narrowed) return { text: t('listViews.empty.noMatch'), action: 'reset', actionText: t('listbar.reset') };
  const create = o.canCreate ? { action: 'create' as const, actionText: o.create } : { action: null, actionText: '' };
  if (o.filtered) return { text: t(o.canCreate ? 'listViews.empty.item' : 'listViews.empty.itemRead', { item: o.item, create: o.create }), ...create };
  return { text: t(o.canCreate ? 'listViews.empty.none' : 'listViews.empty.noneRead', { create: o.create }), ...create };
}
